<template>
  <div id="card">
    <Spinner v-if="isLoading"/>
    <div class="sav-card">
        <div class="sav-card-header" :class="{ red: isExpired(cardData[0]['end_date']), yellow: isGoingToExpire(cardData[0]['end_date']) }">
          <h2 class="sav-card-title">{{ cardHeader }}</h2>
          <div class="flex">
            <router-link :to="'/' + category + '/' + id + '/edit'" class="sav-card-icon">
              <img :src="require('./../assets/icons/edit.png')" alt="Επεξεργασία"/>
            </router-link>
            <router-link :to="'/' + category + '/' + id + '/history'" class="sav-card-icon">
              <img :src="require('./../assets/icons/history.png')" alt="Ιστορικό ασφαλειών"/>
            </router-link>
          </div>
        </div>    

        <div class="sav-card-entries">
            <div class="sav-card-entry" v-for="(value, key, index) in cardData[0]" v-show="key != 'id' && key != 'modified_date' && key != 'modified_by' && key != 'informed' && key != 'informed_date' && key != 'informed_by'" :key="index">
                <h3>{{ cardHeaders[key] }}</h3>
                <p v-if="key == 'start_date' || key == 'end_date'">{{ formatDate(value) }}</p>
                <div v-else-if="(key == 'docs_1' || key == 'docs_2' || key == 'docs_3' || key == 'docs_4') && value" class="flex flex-column">
                  <a v-for="(value, key, index) in value" :key="index" target="_blank" :href="'/docs/' + value">
                    Αρχείο {{ index + 1 }}
                  </a>
                </div>
                <p v-else-if="(key == 'docs_1' || key == 'docs_2' || key == 'docs_3' || key == 'docs_4') && !value">Χωρίς έγγραφο</p>
                <p v-else-if="(key == 'dept')">{{ filterDept(value) }}</p>
                <p v-else>{{ value }}</p>
            </div>
        </div>

        <div v-if="isExpired(cardData[0]['end_date']) || isGoingToExpire(cardData[0]['end_date']) " class="sav-informed-checkbox">
          <span v-if="cardData[0]['informed_by']" class="sav-informed-log">{{ formatDate(cardData[0]['informed_date']) }} - {{ cardData[0]['informed_by'] }}</span>
          <h3>Ενημερώθηκε</h3>
          <input type="checkbox" id="checkbox" v-model="informed" @change="setInformed">
        </div>  

        <div class="sav-card-footer">
          <span class="sav-card-log">Τελευταία αλλαγή στις {{ formatDate(cardData[0]['modified_date']) }} από {{ cardData[0]['modified_by'] }}</span>
          <div class="sav-card-buttons">
            <div v-if="errorMsg" id="error-msg" class="flex flex-align-items-center">
              <b>{{ errorMsg }}</b> 
            </div>
            <router-link :to="'/' + category + '/' + id + '/update'" class="sav-btn sav-btn-red">Ανανέωση ασφάλειας</router-link>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'

export default {
  props: ['id', 'category', 'cardHeaders', 'cardData'],
  components: {
    Spinner
  },
  data() {
      return {
        name: 'Card',
        apiUrl: this.$parent.apiUrl,
        isLoading: false,
        cardHeader: "Ασφάλεια",
        errorMsg: '',
        informed: this.cardData[0]['informed']
      }
  },
  methods: {
    filterDept: function (dept) {
      if (dept == 'Stavros') {
        return 'ΣΤΑΥΡΟΣ';
      } else if (dept == 'Asprovalta') {
        return 'ΑΣΠΡΟΒΑΛΤΑ';
      } else {
        return 'ΧΩΡΙΣ ΚΑΤΑΣΤΗΜΑ';
      }
    },
    jsonParse: function (string) {
      this.test = JSON.parse(string);
      return string;
    },
    isExpired: function (date) {
      // true when date is in the past
      return new Date(date) < new Date()
    },
    isGoingToExpire: function (date) {
      // true when date is in the next 30 days
      let now = new Date(),
        nowPlus30 = new Date(),
        expirationDate = new Date(date);

      nowPlus30.setDate(now.getDate() + 30);
      return (expirationDate > now) && (expirationDate < nowPlus30) 
    },
    formatDate: function (date) {
      // format date dd/mm/yyyy
      let now = new Date(date);
      return this.sliceNumber(now.getDate(), 2) + "/" + this.sliceNumber(now.getMonth() + 1, 2) + "/" + this.sliceNumber(now.getFullYear(), 4)
    },
    sliceNumber: function(number, slice) {
      // return number with custom number of digits
      return ("0" + number).slice(-1 * slice);
    },
    setInformed () {
      let vm = this;
      this.isLoading = true;
      
      let formData = '';
      let url = this.apiUrl + '/post/informed';
      let headers = { 
        headers: {
        'Content-type': 'application/json',
        }
      };

      formData = {
        user: JSON.parse(localStorage.getItem('sav-erp-user')),
        token: this.$cookie.get('sav-erp-token'),
        refreshToken: this.$cookie.get('sav-erp-refresh-token'),
        category: this.category,
        id: this.id,
        informed: this.informed,
        modified_by: JSON.parse(localStorage.getItem('sav-erp-user')).username
      };

      // post request update
      axios.post(url, formData, headers)
        .then(response => {
          if (response.status == 200) {
            this.errorMsg = "";
            this.isLoading = false;
          } else {
            this.errorMsg = response.status + "--" + response.statusText;
            this.isLoading = false;
          } 
        })
        .catch(error => {
          let response = error.response;
          
          if (response.status == 401) {
            localStorage.removeItem('user');    
            vm.$cookie.delete('sav-erp-token');
            vm.$cookie.delete('sav-erp-refresh-token');
            vm.$router.push("/login");
          } else {
            vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
            vm.isLoading = false;
          }
        });
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.cardData[0]['docs_1'] = JSON.parse(this.cardData[0]['docs_1']);
      this.cardData[0]['docs_2'] = JSON.parse(this.cardData[0]['docs_2']);
      this.cardData[0]['docs_3'] = JSON.parse(this.cardData[0]['docs_3']);
      this.cardData[0]['docs_4'] = JSON.parse(this.cardData[0]['docs_4']);
    })
  },
	created: function() {
    // create card header depending on category
    if (this.category == 'car') {
      this.cardHeader = "Ασφάλεια Αυτοκινήτου"
    } else if (this.category == 'moto') {
      this.cardHeader = "Ασφάλεια Μηχανής"
    } else if (this.category == 'house') {
      this.cardHeader = "Ασφάλεια Κατοικίας"
    } else {
      this.cardHeader = "Ασφάλεια Υγείας"
    }
	}
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";

#card {
  margin-top: 20px;
}

#error-msg {
	color: $red;
	font-weight: 400;
	padding: 10px;
	margin-right: 10px;
}
</style>
